export default "__VITE_ASSET__80ced40a__"